/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import AppHandler from '~/core/app-handler'
import TagHandler from '~/core/tag-handler'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import Query from '~/core/query'
import { domReady } from '~/core/runners'
import { fixHeaderLoadingShift } from '~/helpers/ux-optimizations'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query) => Query(query)

/**
 * DOM ready.
 */
domReady(() => {
  Bugsnag().init()
  Commands().init()
  fixHeaderLoadingShift()

  AppHandler().beforeVueInit()
  TagHandler().init()
  Canvas().init()
  AppHandler().afterVueInit()
})
